import * as TYPES from '../actionTypes'

export const setDisplaySidebar = display => dispatch =>
    dispatch({
        type: TYPES.SET_DISPLAY_SIDEBAR,
        payload: display
    })
